import { defaultActionsClasses } from "../../constants";
import { PopupMessageDefaultConfig } from "sb-resp-ui";
export const getPopupActionsConfig = (configActions, context) => {
    let actions = Object.assign({}, PopupMessageDefaultConfig.actions);
    Object.keys(configActions).forEach((key) => {
        actions[key] = {};
        let defaultKey = defaultActionsClasses.hasOwnProperty(key) ? key : "default";
        actions[key].classes = typeof configActions[key].classes === "string" ? `${configActions[key].classes}` : `${defaultActionsClasses[defaultKey].classes}`;
        actions[key].text = configActions[key].text;
        actions[key].focus = configActions[key].focus || false;
        actions[key].onClick = configActions[key].callback || context.hide;
        actions[key].context = configActions[key].context || context;
    });
    return actions;
};
//# sourceMappingURL=getPopupActionsConfig.js.map